import React from "react";
import Select from "react-select";
import { injectIntl } from "react-intl";

const LocalizedSelect = props => {
  const localizedPlaceholder = props.intl.formatMessage({
    id: props.placeholder,
  });

  const colourStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: "white",
      border: "1px solid #aaa",
      height: "auto",
      paddingTop: "4px",
      paddingBottom: "4px",
    }),
    placeholder: styles => ({
      ...styles,
      lineHeight: "40px",
      fontSize: "14px",
      color: "#999",
    }),
  };

  const localizedOptions = props.options.map(opt => {
    return {
      label: props.intl.formatMessage({ id: opt.label }),
      value: opt.value,
    };
  });

  const localizedValue = value => {
    return value.value
      ? localizedOptions.find(o => o.value === value.value)
      : null;
  };

  return (
    <Select
      {...props}
      styles={colourStyles}
      value={localizedValue(props.value)}
      options={localizedOptions}
      placeholder={localizedPlaceholder}
    />
  );
};

export default injectIntl(LocalizedSelect);



// WEBPACK FOOTER //
// ./src/components/Select.js